import { useTranslate } from "@tolgee/react";
import * as PropTypes from "prop-types";
import { ALL_PLATFORM_ICONS } from "../../../../config/icons";
import { getPlatformTranslationKey } from "../../../../utils/utils";
// add prop type

// add prop type

export const PostPreviewTitle: React.FC<any> = ({ platform }: any) => {
  const { t } = useTranslate();
  return (
    <p className="text-primary fw-bolder d-flex align-items-center">
      <i
        style={{ fontSize: "20px" }}
        className={`${ALL_PLATFORM_ICONS[platform]} me-2 text-white`}
      ></i>
      <span className="h5 text-primary mb-0">
        {t(getPlatformTranslationKey(platform))}{" "}
        {t("lomavisCreator.preview.preview")}
      </span>
    </p>
  );
};

PostPreviewTitle.propTypes = {
  platform: PropTypes.string.isRequired,
};
